export default __webpack_public_path__ + "static/media/Ficha Técnica - Suco de  Laranja Concentrado Congelado.945be135.pdf";